import { clsx } from 'clsx';
import React from 'react';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  /**
   * Label text
   */
  children: React.ReactNode;

  /**
   * Whether field is required
   * @default false
   */
  required?: boolean;

  /**
   * Whether label has error state
   * @default false
   */
  error?: boolean;
}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ children, required = false, error = false, className, ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={clsx(
          'block text-sm mb-1.5 transition-colors',
          error ? 'text-danger-600' : 'text-neutral-700',
          className
        )}
        {...props}
      >
        {children}
        {required && (
          <span className="text-danger-500 ml-1" aria-label="obrigatório">
            {/* * */}
          </span>
        )}
      </label>
    );
  }
);

Label.displayName = 'Label';
